import { round } from 'helpers';

export const roundCurrency: typeof round = (value) => round(value, 2);
